import { createDuck } from '@/utils'
import { getAddressList, updateAddress } from '@/services/api/address'
import { ADDRESS_SELECTED } from '@/utils/const'
import { Toast } from 'antd-mobile-v2'

export const GLOBAL_ADDRESS_MAP = {
  1: {
    key: 'province',
    text: '省份',
  },
  2: {
    key: 'city',
    text: '城市',
  },
  3: {
    key: 'district',
    text: '区县',
  },
}
export const duck = createDuck({
  name: 'addressDuck',
  initialState: {
    /** @type {Array<address.AddressItem>} */
    addressList: [],
    addressStatus: 0,
    /** @type {address.AddressItem} */
    userSelectedAddress: {},
  },
  actions: {
    /**
     * 获取用户地址列表
     * @returns
     */
    fetchAddressList() {
      return async dispatch => {
        const { data, error } = await getAddressList()
        if (!error) {
          const _d = data.filter(item => item.status === ADDRESS_SELECTED)
          dispatch(
            duck.change({
              addressStatus: 1,
              addressList: data,
              userSelectedAddress: _d[0],
            }),
          )
        }
      }
    },

    /**
     * 创建地址
     * @param {addressApi.CreateParam} param
     * @returns
     */
    createAddress(param) {
      //updateAddress
      return async dispatch => {
        const { error } = await updateAddress(param)

        if (error) {
          Toast.info(error.message || param.id ? '更新地址失败' : '新建地址失败')
        }
      }
    },

    // /**
    //  * 创建地址
    //  * @param {addressApi.CreateParam} param
    //  * @returns
    //  */
    // updageAddress(param) {
    //   return async dispatch => {
    //     const { error } = await updateAddress(param)
    //     if (!error) {
    //       dispatch(duck.fetchAddressList())
    //     } else {
    //       Toast.info(error.message || param.id ? '更新地址失败' : '新建地址失败')
    //     }
    //   }
    // },
  },
})
